// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IServiceLiteDto } from './IServiceLiteDto';
import {
    IServiceLiteDtoFromJSON,
    IServiceLiteDtoFromJSONTyped,
    IServiceLiteDtoToJSON,
    IServiceLiteDtoToJSONTyped,
} from './IServiceLiteDto';

/**
 * 
 * @export
 * @interface ICategoryServiceDto
 */
export interface ICategoryServiceDto {
    /**
     * 
     * @type {number}
     * @memberof ICategoryServiceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICategoryServiceDto
     */
    category?: string;
    /**
     * 
     * @type {Array<IServiceLiteDto>}
     * @memberof ICategoryServiceDto
     */
    services?: Array<IServiceLiteDto>;
}

/**
 * Check if a given object implements the ICategoryServiceDto interface.
 */
export function instanceOfICategoryServiceDto(value: object): value is ICategoryServiceDto {
    return true;
}

export function ICategoryServiceDtoFromJSON(json: any): ICategoryServiceDto {
    return ICategoryServiceDtoFromJSONTyped(json, false);
}

export function ICategoryServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICategoryServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'category': json['category'] == null ? undefined : json['category'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(IServiceLiteDtoFromJSON)),
    };
}

export function ICategoryServiceDtoToJSON(json: any): ICategoryServiceDto {
    return ICategoryServiceDtoToJSONTyped(json, false);
}

export function ICategoryServiceDtoToJSONTyped(value?: ICategoryServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category': value['category'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(IServiceLiteDtoToJSON)),
    };
}

